import Component from '../core/Component'

export default class FormItem extends Component {
    constructor(element, options) {
        super(element, options)

        this.inputEl = null
    }

    prepare() {
        this.inputEl = this.element.querySelector('.FormInput')
        if (this.inputEl) {
            this.inputEl.addEventListener('focus', this.handleInputOrCompChangeState)
            this.inputEl.addEventListener('blur', this.handleInputOrCompChangeState)
            this.inputEl.addEventListener('change', this.handleInputOrCompChangeState)
            this.update()
        }

        const compEl = this.element.querySelector('.FormDaterange, .FormSelect')
        this.comp = compEl ? Component.getFromElement(compEl) : null
        if (this.comp) {
            this.comp.element.addEventListener('focus', this.handleInputOrCompChangeState)
            this.comp.element.addEventListener('blur', this.handleInputOrCompChangeState)
            this.comp.element.addEventListener('change', this.handleInputOrCompChangeState)
            this.update()
        }
    }

    handleInputOrCompChangeState = () => {
        this.update()
    }
    
    update() {
        if (this.inputEl) {
            this.element.classList.toggle('is-empty', !this.inputEl.value)
            this.element.classList.toggle('is-focus', document.activeElement === this.inputEl)
        }
        
        if (this.comp) {
            this.element.classList.toggle('is-empty', this.comp.isEmpty())
            this.element.classList.toggle('is-focus', this.comp.isFocus())
        }
    }
}